import { LoginRequest, PerformanceData, type BaseResponse } from "./Data.js";
import jQuery from 'jquery';
import { PushClientManager } from "./pushclient/PushClientManager.js";
import { currentLanguageId, setLanguageId } from "../../tools/language/LanguageManager.js";
// export var credentials: { username: string, password: string } = { username: null, password: null };

export var SINGLEUSETOKEN: string = "singleUseToken";

export class PerformanceCollector {
    static performanceData: PerformanceData[] = [];
    static performanceDataCount: number = 0;
    static lastTimeSent: number = performance.now();

    static registerPerformanceEntry(url: string, startTime: number) {
        let pe: PerformanceData = PerformanceCollector.performanceData.find(pe => pe.url == url);
        if (pe == null) {
            pe = { count: 0, sumTime: 0, url: url };
            PerformanceCollector.performanceData.push(pe);
        }
        pe.count++; //Test
        let dt = Math.round(performance.now() - startTime);
        pe.sumTime += dt;
        PerformanceCollector.performanceDataCount++;
        // console.log("Performance entry for path " + pe.url + ": " + dt + " ms, aggregated: " + pe.sumTime + " for " + pe.count + " requests.");
    }

    static sendDataToServer() {
        if (performance.now() - PerformanceCollector.lastTimeSent > 3 * 60 * 1000) {
            let request = {
                data: PerformanceCollector.performanceData
            }

            PerformanceCollector.performanceData = [];
            PerformanceCollector.performanceDataCount = 0;
            PerformanceCollector.lastTimeSent = performance.now();

            ajax("collectPerformanceData", request, () => { })

        }

    }

}

export var csrfToken: string = "";


export function ajax(url: string, request: any, successCallback: (response: any) => void,

    errorCallback?: (message: string) => void) {

    if (!url.startsWith("http")) {
        url = "servlet/" + url;
    }


    showNetworkBusy(true);
    let time = performance.now();

    let headers: { [key: string]: string; } = {};
    if (csrfToken != null) headers = { "x-token-pm": csrfToken };

    jQuery.ajax({
        type: 'POST',
        async: true,
        data: JSON.stringify(request),
        contentType: 'application/json',
        headers: headers,
        url: url,
        success: function (response: any) {

            PerformanceCollector.registerPerformanceEntry(url, time);

            if (response["csrfToken"] != null) {
                csrfToken = response["csrfToken"];
                PushClientManager.getInstance().open();
            }

            showNetworkBusy(false);
            if (response.success != null && response.success == false || typeof (response) == "string" && response == '') {
                let error = "Fehler bei der Bearbeitung der Anfrage"
                if (response.message != null) error = response.message;
                if (response.error != null) error = response.error;

                console.log("Netzwerkfehler: " + error);

                if (errorCallback) errorCallback(error);
            } else {
                successCallback(response);
            }
            return;

        },
        error: function (jqXHR, message) {
            showNetworkBusy(false);
            if (errorCallback) {
                let statusText = "Server nicht erreichbar."
                if (jqXHR.status != 0) {
                    statusText = "" + jqXHR.status
                }
                if (jqXHR.status == 401) {
                    statusText = "Doppellogin während einer laufenden Prüfung. Du wurdest ausgeloggt.";
                }
                errorCallback(statusText);
                return;
            }
        }
    });
}

export function showNetworkBusy(busy: boolean) {
    if (busy) {
        jQuery('.jo_network-busy').css('display', 'block');
    } else {
        jQuery('.jo_network-busy').css('display', 'none');
    }
}

export async function extractCsrfTokenFromGetRequest(retrieveNewCsrfToken: boolean = false) {
    let url = window.location.href;
    let token = fetchGetParameterValueIntern(url, "csrfToken");
    if (token != null && token.length > 0) {
        csrfToken = token;
    }

    if (retrieveNewCsrfToken) {
        await ajaxAsync("/servlet/retrieveNewCsrfToken", {});
    }
}

export async function extractSingleUseSessionTokenFromGetRequestAndRetrieveNewCsrfToken() {
    let url = window.location.href;

    let csrfTokenFromGetRequest = fetchGetParameterValueIntern(url, "csrfToken");
    if (csrfTokenFromGetRequest == null) {
        let token = fetchGetParameterValueIntern(url, SINGLEUSETOKEN);

        await ajaxAsync("/servlet/retrieveNewCsrfToken?" + SINGLEUSETOKEN + "=" + token, {});

        let index = url.indexOf("?");
        let newUrl = url.substring(0, index) + "?csrfToken=" + csrfToken;

        let menuItem = fetchGetParameterValueIntern(url, "menuItem");
        if (menuItem != null) {
            newUrl += "&menuItem=" + menuItem;
        }

        window.location.href = newUrl;
    } else {
        csrfToken = csrfTokenFromGetRequest;
    }

}
export function fetchGetParameterValue(parameterIdentifier: string): string | null {
    let url = window.location.href;
    return fetchGetParameterValueIntern(url, parameterIdentifier);
}

function fetchGetParameterValueIntern(url: string, parameterIdentifier: string): string | null {
    let index = url.indexOf(parameterIdentifier + "=");
    if (index >= 0) {
        let endIndex = url.indexOf('&', index);
        if (endIndex < 0) endIndex = url.length;
        return url.substring(index + (parameterIdentifier + "=").length, endIndex);
    }
    return null;
}

export async function extractLanguageFromGetRequest(retrieveNewCsrfToken: boolean = false) {
    let url = window.location.href;
    let lang = fetchGetParameterValueIntern(url, 'lang');
    if (lang != null) {
        setLanguageId(lang);
    }
}



export async function ajaxAsync(url: string, data: any): Promise<BaseResponse> {
    let headers: [string, string][] = [["content-type", "text/json"]];

    if (csrfToken != null && csrfToken.length > 0) {
        headers.push(["x-token-pm", csrfToken]);
    }

    showNetworkBusy(true);
    try {
        let response = await fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        })

        let obj: any = await response.json()

        if (obj["csrfToken"] != null) {
            csrfToken = obj["csrfToken"];
            PushClientManager.getInstance().open();
        }

        if (response.status == 401) {
            alert("Logout wegen Doppellogin während einer Prüfung.");
            location.reload();
        }

        if (obj == null) {
            alert("Fehler beim Übertragen der Daten.");
        } else if (obj.success != true) {
            alert("Fehler beim Übertragen der Daten:\n" + obj.message);
        }
        showNetworkBusy(false);
        return obj;
    } catch (exception) {
        showNetworkBusy(false);
        return {
            success: false,
            message: "Es ist ein Fehler aufgetreten: " + exception
        }
    }
}
